module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-13.e8d5c62b.jpg";